export const queryKeys = {
  profile: ['profile'] as const,
  dashboard: ['dashboard'] as const,
  categories: ['categories'] as const,
  buyerCurrentJobs: ['jobs', 'buyer', 'current'] as const,
  buyerPastJobs: ['jobs', 'buyer', 'past'] as const,
  availableJobs: ['jobs', 'r8tr', 'available'] as const,
  currentJobs: ['jobs', 'r8tr', 'current'] as const,
  buyerCost: (
    categoryId?: string | number | null,
    askingPrice?: number | null
  ) => ['costs', 'buyer', categoryId ?? null, askingPrice ?? null] as const,
  jobDetail: (jobId?: string) => ['jobs', 'detail', jobId] as const,
  jobPdf: (jobId?: string | number) => ['jobs', 'pdf', jobId] as const,
  scrappedItem: (itemId?: string | null) =>
    ['jobs', 'scrapped', itemId] as const,
  notifications: (limit?: number) => ['notifications', limit ?? 'all'] as const,
  ratingCategories: (jobId?: string) =>
    ['rating', 'categories', jobId] as const,
  ratingOptions: (optionId?: string) =>
    ['rating', 'options', optionId] as const,
  ratingDamages: (criteriaId?: string, jobId?: string) =>
    ['rating', 'damages', criteriaId, jobId] as const,
  ratingVideos: (jobId?: string) => ['rating', 'videos', jobId] as const,
  ratingSpecialMessage: (jobId?: string) =>
    ['rating', 'special-message', jobId] as const,
};
